import { render } from "./AttributeEmail.vue?vue&type=template&id=4c0cd95e&scoped=true"
import script from "./AttributeEmail.vue?vue&type=script&lang=js"
export * from "./AttributeEmail.vue?vue&type=script&lang=js"

import "./AttributeEmail.vue?vue&type=style&index=0&id=4c0cd95e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0cd95e"]])

export default __exports__